import PropTypes from 'prop-types';
import * as React from 'react';
import {Checkbox} from 'mc/lib/field';
import type ColumnSynchronizer from './ColumnSynchronizer';
import DataTableHeaderCell from './DataTableHeaderCell';
import type {ColumnPropType} from './propTypes';
import {columnPropType, columnSynchronizerPropType} from './propTypes';

export type Props = {
    column: ColumnPropType,
    columnSynchronizer?: ColumnSynchronizer,
    value?: boolean,
    onChange?: (value: boolean, column: ColumnPropType) => void,
};

export default class DataTableHeaderSelectionCell extends React.PureComponent<Props> {

    static propTypes = {
        column: columnPropType.isRequired,
        columnSynchronizer: columnSynchronizerPropType,
        value: PropTypes.bool,
        onChange: PropTypes.func,
    };

    static defaultProps = {
        value: false,
    };

    props: Props;

    handleChange = (): void => {
        const {column, value, onChange} = this.props;
        if (onChange) {
            onChange(!value, column);
        }
    };

    render(): React.ReactNode {
        const {value, ...otherProps} = this.props;
        return (
            <DataTableHeaderCell {...otherProps}>
                <Checkbox value={value} onChange={this.handleChange}/>
            </DataTableHeaderCell>
        );
    }

}
